"use client";

import { useEffect, useState } from "react";

import { Icon } from "@perceptron/ui/components/icon";
import { ToggleGroup, ToggleGroupItem } from "@perceptron/ui/components/toggleGroup";
import { useTheme } from "next-themes";

export function ToggleTheme() {
  const [mounted, setMounted] = useState(false);
  const { theme, setTheme } = useTheme();

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <ToggleGroup
      className="hidden items-center rounded-xl border bg-background-alt-2 p-1 dark:border-none sm:inline-flex"
      size={"sm"}
      type="single"
      // Always pass a defined value — `undefined` would put Radix in
      // uncontrolled mode pre-mount and the post-mount switch to a string
      // would flip it to controlled (React warns). Empty string is Radix's
      // "no item selected" sentinel for type="single".
      value={mounted ? (theme ?? "") : ""}
      onValueChange={(value) => value && setTheme(value)}
    >
      <ToggleGroupItem
        aria-label="Light mode"
        className="rounded-lg hover:bg-background hover:text-accent-foreground data-[state=on]:bg-background data-[state=off]:text-foreground-secondary data-[state=on]:text-accent-foreground hover:data-[state=off]:text-accent-foreground"
        disabled={!mounted}
        value="light"
      >
        <Icon name="sun" />
      </ToggleGroupItem>
      <ToggleGroupItem
        aria-label="Dark mode"
        className="rounded-lg hover:bg-background hover:text-accent-foreground data-[state=on]:bg-background data-[state=off]:text-foreground-secondary data-[state=on]:text-accent-foreground hover:data-[state=off]:text-accent-foreground"
        disabled={!mounted}
        value="dark"
      >
        <Icon name="moon" />
      </ToggleGroupItem>
      <ToggleGroupItem
        aria-label="System theme"
        className="rounded-lg hover:bg-background data-[state=on]:bg-background data-[state=off]:text-foreground-secondary data-[state=on]:text-accent-foreground hover:data-[state=off]:text-accent-foreground"
        disabled={!mounted}
        value="system"
      >
        <Icon name="monitor" />
      </ToggleGroupItem>
    </ToggleGroup>
  );
}
